import { useEffect } from 'react';
import { useDebouncedTrackAction } from '@paradigm/features/src/analytics';

export default function useKeybinding(
  key: KeyboardEvent['key'],
  onKeyDown: (event: KeyboardEvent) => void,
  onKeyUp: (event: KeyboardEvent) => void,
) {
  const track = useDebouncedTrackAction();

  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === key) {
        event.preventDefault();
        onKeyDown(event);
        track('shortcut key pressed', { key });
      }
    }

    function handleKeyUp(event: KeyboardEvent) {
      if (event.key === key) {
        event.preventDefault();
        onKeyUp(event);
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [key, onKeyDown, onKeyUp, track]);
}
